/* eslint-disable */
module.exports = {
  "version": {
    "backend": "3.8.1",
    "frontend": "3.8.1"
  }
}